import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-deploy",
  "use": "icon-deploy-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-deploy\"><defs><style></style></defs><path d=\"M877.952 447.616v-.256a272 272 0 0 0-479.68-175.68 166.144 166.144 0 0 0-226.016 155.296c0 4.768.32 9.6.704 14.144A196.896 196.896 0 0 0 206.592 832H448V576H304l208-208 208 208H576v256h241.408a196.96 196.96 0 0 0 60.544-384.384z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol